import { LoadingSpinner } from '@/components/LoadingSpinner'
import { CheckmarkFilledIcon } from '@/components/icons/CheckmarkFilledIcon'
import { ErrorIcon } from '@/components/icons/ErrorIcon'
import { WarningOutlineIcon } from '@/components/icons/WarningOutlineIcon'
import { CloseButton } from '@/components/ui/CloseButton'
import { cn } from '@/lib/utils'

export type SnackbarProps = {
  heading?: string
  message: string | string[]
  variant: 'success' | 'error' | 'loading' | 'warning'
  onClose: () => unknown
  classNames?: {
    container?: string
    success?: string
    error?: string
    loading?: string
    warning?: string
    close?: string
  }
}

export function Snackbar({ heading, message, variant, onClose, classNames }: SnackbarProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded rounded-s bg-green-500 p-2 text-white',
        variant === 'error' && 'bg-[#CD1D32] dark:bg-[#FF6669]',
        variant === 'success' && 'bg-[#316833] dark:bg-[#08AB50]',
        variant === 'loading' && 'bg-gray-500',
        variant === 'warning' && 'bg-[#DC5018] dark:bg-[#F5A622]',
        classNames?.container
      )}
    >
      {variant === 'success' ? (
        <CheckmarkFilledIcon
          className={cn('ml-2 w-6 flex-shrink-0 [&>*]:fill-white', classNames?.success)}
        />
      ) : null}
      {variant === 'error' ? (
        <ErrorIcon className={cn('ml-2 w-6 flex-shrink-0 [&>*]:fill-white', classNames?.error)} />
      ) : null}
      {variant === 'loading' ? (
        <LoadingSpinner className={cn('ml-2 w-6 flex-shrink-0', classNames?.loading)} />
      ) : null}
      {variant === 'warning' ? (
        <WarningOutlineIcon className={cn('ml-2 w-6 flex-shrink-0', classNames?.warning)} />
      ) : null}
      <div>
        {heading !== undefined ? <p className="font-bold">{heading}</p> : null}
        {Array.isArray(message) ? (
          message.map((item) => <p key={item}>{item}</p>)
        ) : (
          <p>{message}</p>
        )}
      </div>
      <CloseButton
        onClick={onClose}
        autoFocus={false}
        className={cn('ml-auto mr-2 [&>*]:fill-white', classNames?.close)}
      />
    </div>
  )
}
